import { render, staticRenderFns } from "./SettingsIndexProvider.vue?vue&type=template&id=5068e520&"
import script from "./SettingsIndexProvider.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports